import { render, staticRenderFns } from "./selected.vue?vue&type=template&id=34b3ee37&scoped=true&"
import script from "./selected.vue?vue&type=script&lang=js&"
export * from "./selected.vue?vue&type=script&lang=js&"
import style0 from "./selected.vue?vue&type=style&index=0&id=34b3ee37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b3ee37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VContainer,VIcon})
